import { computed } from 'vue'

import type { VoiceRecorderBarLabels } from '../types/voice.types'

/** i18n key sets for VoiceRecorderBar labels across communities surfaces. */
export const VOICE_RECORDER_LABEL_KEYS = {
  chats: {
    recording: 'chats.voiceNote.recording',
    pause: 'chats.voiceNote.pause',
    resume: 'chats.voiceNote.resume',
    cancel: 'chats.voiceNote.cancel',
    confirm: 'chats.voiceNote.send',
    waveform: 'chats.voiceNote.waveform',
  },
  comments: {
    recording: 'comments.editor.voiceNote.recording',
    pause: 'comments.editor.voiceNote.pause',
    resume: 'comments.editor.voiceNote.resume',
    cancel: 'comments.editor.voiceNote.cancel',
    confirm: 'comments.editor.voiceNote.send',
    waveform: 'comments.editor.voiceNote.waveform',
  },
  posts: {
    recording: 'posts.editor.voiceNote.recording',
    pause: 'posts.editor.voiceNote.pause',
    resume: 'posts.editor.voiceNote.resume',
    cancel: 'posts.editor.voiceNote.cancel',
    confirm: 'posts.editor.voiceNote.stop',
    waveform: 'posts.editor.voiceNote.waveform',
  },
} as const satisfies Record<string, Record<keyof VoiceRecorderBarLabels, string>>

export function useVoiceRecorderLabels(t: (key: string) => string, keys: Record<keyof VoiceRecorderBarLabels, string>) {
  return computed<VoiceRecorderBarLabels>(() => ({
    recording: t(keys.recording),
    pause: t(keys.pause),
    resume: t(keys.resume),
    cancel: t(keys.cancel),
    confirm: t(keys.confirm),
    waveform: t(keys.waveform),
  }))
}
